<template>
  <div class="LoadingComponent align-items-center justify-content-center full-height">
    <div class="pt-1 pl-1">
      <MuiDotTag
        :size="10"
        type="main"
      />
    </div>
    <div class="pt-1 pl-1">
      <MuiDotTag
        :size="10"
        type="ground"
      />
    </div>
    <div class="pt-1 pl-1">
      <MuiDotTag
        :size="10"
        type="success"
      />
    </div>
  </div>
</template>
<script>

import { MuiDotTag } from '@ubeeqo/motion-ui';

export default {
  name: 'LoadingComponent',
  components: {
    MuiDotTag,
  },
};
</script>
